import { render, staticRenderFns } from "./LoadMenu.vue?vue&type=template&id=a0b5924a&"
import script from "./LoadMenu.vue?vue&type=script&lang=js&"
export * from "./LoadMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports